/* import __COLOCATED_TEMPLATE__ from './multilingual.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type ApplicationInstance from '@ember/application/instance';
import type GlossaryService from 'embercom/services/glossary-service';

interface Args {
  model: any;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class Multilingual extends Component<Signature> {
  @service declare appService: $TSFixMe;
  @service declare glossaryService: GlossaryService;
  @tracked isSideDrawerOpen = false;
  @tracked rowData: $TSFixMe;
  @tracked mode: 'new' | 'edit' = 'new';

  constructor(owner: ApplicationInstance, args: Args) {
    super(owner, args);
  }

  @action
  showLearnMore() {
    // Open learn more documentation
    window.Intercom('showArticle', 9744851);
  }

  @action
  addManually() {
    this.openSideDrawer('new');
  }

  @action
  importCsv() {
    // Feature to be implemented
    this.isSideDrawerOpen = false;
  }

  @action
  async closeSideDrawer(updatedData?: any) {
    // If data was updated, reload the glossary data
    if (updatedData) {
      await this.glossaryService.loadGlossary();
    }

    this.isSideDrawerOpen = false;
  }

  @action
  openSideDrawer(mode: 'new' | 'edit', rowData?: any) {
    this.isSideDrawerOpen = true;
    this.rowData = rowData;
    this.mode = mode;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Multilingual': typeof Multilingual;
  }
}
